/**
 * Helper function to transform the fetch eligible RTK items API response data to be
 * consumed in the select items step component of the RTK flow.
 *
 * @param {Object[]} orders List of orders containing items eligible for RTK
 * @param {Object[]} orders.rentToKeepItems List of RTK-eligible items within order
 * @param {Object[]} orders.rentToKeepItems.photos List of RTK-eligible items within order
 * @param {Object[]} orders.rentToKeepItems.purchased List of RTK-eligible items within order
 * @returns {Object[]} Transformed list of RTK-eligible orders
 */
export const transformRTKEligibleOrders = (orders) =>
  orders.map(({rentToKeepItems, ...rest}) => ({
    ...rest,
    rentToKeepItems: rentToKeepItems.map(({photos, purchased, ...item}) => ({
      ...item,
      id: `${item.orderLookProductId}:${item.productSetId}`,
      isPurchased: purchased,
      photo: photos[0],
    })),
  }))
